import { FeedbackModel } from './feedback.interface';

export interface ChatHistoryMessage {
  UserMessage: string;
  AIResponse: string;
  CreatedDate: string;
  Feedback?: FeedbackModel;
  Sources?: string[];
  VoiceNoteId?: string;
  VoiceNoteSeconds?: number;
  VoiceNoteContentType?: string;
}

export function mapChatHistoryMessage(msg: any): ChatHistoryMessage {
  return {
    UserMessage: msg.UserMessage,
    AIResponse: msg.AIResponse,
    CreatedDate: msg.CreatedDate,
    Feedback: msg.Feedback ? {
      isLiked: msg.Feedback.IsLiked ?? msg.Feedback.isLiked,
      comment: msg.Feedback.Comment ?? msg.Feedback.comment
    } : undefined,
    Sources: msg.Sources
      ? (typeof msg.Sources === 'string' ? JSON.parse(msg.Sources) : msg.Sources)
      : undefined,
    VoiceNoteId: msg.VoiceNoteId || undefined,
    VoiceNoteSeconds: typeof msg.VoiceNoteSeconds === 'number' ? msg.VoiceNoteSeconds : undefined,
    VoiceNoteContentType: msg.VoiceNoteContentType || undefined,
  };
}

export interface ChatHistoryItem {
  id: string;
  messagesJson: string;
  chatLabel: string;
}

export interface ChatHistoryData {
  chatHistories: ChatHistoryItem[];
}

export interface ChatHistoryResponse {
  isSuccess: boolean;
  code: number;
  message: string;
  data: ChatHistoryData;
  errors: string[];
}
